import { BaseActions } from '@/models/Common/Actions/BaseActions';
import debug from 'debug';

import { execAction } from '@/models/Common/Actions/handler';
import { ResponseEither } from '@/models/Common/ResponseEither';
import { IEventListPayloadItem } from '@/models/Display/Event/interfaces/IDisplayEventListPayload';
import { IDisplayEventListRequestParams } from '@/models/Display/Event/interfaces/IDisplayEventListRequestParams';
import DisplayEventRequestBuilder from '@/models/Display/Event/DisplayEventRequestBuilder';

const log = debug('sunny:EventActions');

export default class DisplayEventActions extends BaseActions<DisplayEventRequestBuilder> {
  list(params: IDisplayEventListRequestParams): Promise<ResponseEither<IEventListPayloadItem[]>> {
    log('Getting data of event list');
    return execAction('display event list', this.requestBuilder.createGetEventListQuery(params));
  }
}
